import { DateSerializer, Field, From, Optional, Schema } from '@bonusly/schema';

import { DimensionKey } from '../queries/recognition-analysis';
import { User } from './users';

// This is from the api/v2/bonuses controller, which uses the BonusDecorator to decorate bonuses.
// Note that I didn't add fully populate this but it can be updated to include more fields and relationships.
// I'm going to add a BOUNTY ticket to create an updated endpoint for fetching bonuses that follows modern patterns and does
// not rely on the old API or decorator pattern

@Schema()
export class DecoratedAttachment {
	@Field()
	@From('gif')
	@Optional()
	public gif = '';

	@Field()
	@From('videoThumbnailUrl')
	@Optional()
	public videoThumbnailUrl = '';

	@Field()
	@From('videoPosterUrl')
	@Optional()
	public videoPosterUrl = '';
}

@Schema()
export class Dimension {
	@Field()
	@From('key')
	public key: DimensionKey = DimensionKey.Contextual;

	@Field(Boolean)
	@From('matches')
	public matches = false;

	@Field()
	@From('reason')
	public reason = '';
}

@Schema()
export class QualityScore {
	@Field([Dimension])
	@From('dimensions')
	public dimensions = [];

	@Field()
	@From('score')
	public score = 0;
}

@Schema()
export class DecoratedScoredBonus {
	@Field()
	@From('id')
	public id = '';

	@Field()
	@From('reason')
	public reason = '';

	@Field(QualityScore)
	@From('qualityScore')
	public qualityScore = new QualityScore();

	@Field([DecoratedAttachment])
	@From('attachments')
	public attachments: DecoratedAttachment[] = [];

	@Field(DateSerializer)
	@From('createdAt')
	public createdAt = new Date();

	@Field()
	@From('familyAmount')
	public familyAmount = 0;

	@Field(User)
	@From('giver')
	public giver = new User();

	@Field(Number)
	@From('reactionCount')
	public reactionCount = 0;

	@Field(Number)
	@From('commentCount')
	public commentCount = 0;

	@Field([User])
	@From('receivers')
	public receivers: User[] = [];

	get imageUrl(): string {
		const attachment = this.attachments[0];

		if (!attachment) {
			return '';
		}

		return attachment.gif || attachment.videoThumbnailUrl || attachment.videoPosterUrl || '';
	}

	get detailUrl() {
		return `/bonuses/${this.id}`;
	}
}
